import { render, staticRenderFns } from "./SettingsSchedulePage.vue?vue&type=template&id=44d23b0a"
import script from "./SettingsSchedulePage.vue?vue&type=script&lang=js"
export * from "./SettingsSchedulePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports